module.exports = __webpack_public_path__ + "static/media/pinelab.03cbd63d.png";